import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import GeoSidebar from "./GeoSidebar";
import FunctionalTopNav from "./FunctionalTopNav";

export default function ContextShell() {
  const [isSidebarPinnedOpen, setIsSidebarPinnedOpen] = useState(true);
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);

  return (
    <div className="flex h-screen overflow-hidden bg-background">
      {isMobileSidebarOpen && (
        <button
          type="button"
          className="fixed inset-0 z-40 bg-black/45 md:hidden"
          onClick={() => setIsMobileSidebarOpen(false)}
          aria-label="Close location navigation"
        />
      )}
      <GeoSidebar
        isPinnedOpen={isSidebarPinnedOpen}
        onPinnedOpenChange={setIsSidebarPinnedOpen}
        isMobileOpen={isMobileSidebarOpen}
        onMobileClose={() => setIsMobileSidebarOpen(false)}
      />
      <div
        className={`flex-1 flex flex-col min-w-0 transition-[margin-left] duration-200 ease-out ${
          isSidebarPinnedOpen ? "ml-72" : "ml-16"
        } max-md:ml-0`}
      >
        <FunctionalTopNav onOpenLocationNav={() => setIsMobileSidebarOpen(true)} />
        <main className="flex-1 overflow-auto bg-background">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
